<template>
    <teleport to="#modal">
        <Loading
            :visible="lista.loading"
        >
        </Loading>
    </teleport>
    <div class="m-auto px-8 md:px-20">
        <div class="max-w-screen-2xl m-auto">
            <div class="py-5 text-2xl font-bold">
                Lista Aziende Gruppo
            </div>
            <div class="grid grid-cols-4 gap-4 mb-3">
                <div class="flex flex-col col-span-2">
                    <Field field_name="Cerca" @update:modelValue="lista.debounceSearch" v-model="lista.search"
                           placeholder="Cerca"></Field>
                </div>
            </div>
            <div class="rotate-x-180 overflow-x-scroll">
                <NextTable class="rotate-x-180 table-auto w-full border-separate border-spacing-3 py-4"
                           v-model:cols="cols"
                           :rows="lista.rows" @order-update="lista.updateCols">
                    <template v-for="(c, j) in lista.rows" :key="j" v-slot:[`td_${j}_4`]="context">
                        <router-link :to="{name:'DettaglioAziendaGruppo', params:{id:context.context.row.id}}"
                                     class="text-center inset-0 absolute flex items-center justify-center"><i
                            class="icon-chevron_destra"></i></router-link>
                    </template>
                </NextTable>

            </div>

            <InfiniteLoading @infinite="lista.fetchNextPage" :identifier="lista.infiniteIdentifier" style="min-height: 1px">
                <template #complete>
                    <div class="text-center pb-3">Non ci sono altre ditte.</div>
                </template>
            </InfiniteLoading>
        </div>
    </div>
</template>

<script lang="ts">
import {Options, Vue, setup} from 'vue-class-component';
import NextTable from "@/components/NextTable.vue";
import InfiniteLoading from "v3-infinite-loading";
import Loading from "@/components/Loading.vue";
import ContextMenuOpener from "@/setup/ContextMenuOpener";
import Field from "@/components/Field.vue";
import Lista from "@/setup/ListaCerca";
import {aziendeGruppoManager} from "@/api/AziendeGruppo";

@Options({
    name:'ListaAzinedeGruppo',
    components: {
        Loading,
        Field,
        NextTable,
        InfiniteLoading
    }
})
export default class ListaAzinedeGruppo extends Vue {
    cmOpener: any = setup(() => ContextMenuOpener())
    lista: any = setup(()=>Lista(aziendeGruppoManager, this.cols))
    visible = false

    mounted() {
        this.lista.fetchData()
    }

    cols = [
        {
            name: 'id',
            prop: 'id',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Azienda',
            prop: 'nome',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'CG18_key',
            prop: 'CG18_key',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'CG16_key',
            prop: 'CG16_key',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: '',
            prop: '',
            orderable: false,
            class: 'min-w-10 w-10 whitespace-nowrap',
            td_class: 'relative bg-next-gray-md-dark hover:bg-next-orange hover:text-white',
            resizable: false
        }

    ]
}

</script>


<style lang="scss">

</style>
